module.exports = __webpack_public_path__ + "img/word_google_docs.5f25e030.png";